import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedLoginRoute from "./components/ProtectLoginRoute";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Reports from "./components/Reports";
import ReportDetail from "./components/ReportDetail";
import TransactionDetail from "./components/TransactionDetail";
import StudentLists from "./components/StudentLists";
import StudentDetails from "./components/StudentDetails";
import axios from "axios";
import ReportLists from "./components/ReportLists";
import ReportView from "./components/ReportView";
import PaymentReport from "./components/PaymentReport";
import DisabledFiles from "./components/DisabledFiles";
import DummyRegistrationCard from "./components/DummyRegistrationCard";
import DummyAdmitCardStudents from "./components/DummyAdmitCardStudents";
import EditUser from "./components/EditUser";
import EditPersonlDetails from "./components/EditPersonlDetails";
import AdmitCardList from "./components/AdmitCardList";
import MultipleAdmiCards from "./components/MultipleAdmiCards";
import AdmitCardDownloadFile from "./components/AdmitCardDownloadFile";

function App() {
  if (false) {
    return <DummyRegistrationCard />;
  }
  return (
    <Router>
      <ToastContainer position="top-right" />
      <Routes>
        <Route
          path="/login"
          element={
            <ProtectedLoginRoute>
              <Login />
            </ProtectedLoginRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/:employeeId"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report/:reportId"
          element={
            <ProtectedRoute>
              <ReportDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute>
              <TransactionDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/school-details/:schoolId"
          element={
            <ProtectedRoute>
              <StudentLists />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report-details/:schoolId"
          element={
            <ProtectedRoute>
              <ReportLists />
            </ProtectedRoute>
          }
        />
        <Route
          path="/disabled-schools"
          element={
            <ProtectedRoute>
              <DisabledFiles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-user"
          element={
            <ProtectedRoute>
              <EditUser />
            </ProtectedRoute>
          }
        />
        <Route path="/edit-details" element={<EditPersonlDetails />} />

        <Route
          path="/dummy-admit-schools"
          element={
            <ProtectedRoute>
              <DummyAdmitCardStudents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-details/:schoolId"
          element={
            <ProtectedRoute>
              <StudentDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report-view/:reportId"
          element={
            <ProtectedRoute>
              <ReportView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-report"
          element={
            <ProtectedRoute>
              <PaymentReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/download-report"
          element={
            <ProtectedRoute>
              <AdmitCardDownloadFile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admit-card-list/:schoolId"
          element={
            <ProtectedRoute>
              <AdmitCardList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admit-card/:id"
          element={
            <ProtectedRoute>
              <MultipleAdmiCards />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
